<template>
    <rkm-form ref="Form">
        <rkm-area
            title="Assinatura eletrônica"
            type="fieldset"
        >
            <rkm-form-checkbox v-model="model.assinaturaEletronica">
                Utilizar assinatura eletrônica
            </rkm-form-checkbox>
        </rkm-area>

        <rkm-area
            title="Administração de medicamentos"
            type="fieldset"
        >
            <rkm-form-checkbox v-model="model.exigirDuplaChecagemMedicamento">
                Exigir dupla checagem na administração de medicamentos
            </rkm-form-checkbox>
        </rkm-area>

        <rkm-area
            class="mb-3"
            title="Plantão"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        append="Minutos"
                        label="Tempo adicional para o plantão"
                        number
                        v-model="model.tempoAdicionalPlantao"
                        :validations="validations.tempoAdicionalPlantao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <box-servico-enfermagem :data="{ additionals: additionals.servicosEnfermagem, model }" />
        <box-atendimento-medico :data="{ form, model: model.atendimentoMedico }" />

        <rkm-area
            title="Faturamento automático"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.faturamentoAutomaticoEnfermagem">
                        Faturar prescrição interna e exame solicitado ao imprimir a FAA eletrônica na lista de pacientes da enfermagem
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col class="pl-0">
                    <rkm-icon
                        class="info"
                        icon="info-circle"
                        id="faturamento-automatico-info"
                    />

                    <rkm-popover
                        placement="top"
                        target="faturamento-automatico-info"
                        title="Faturamento automático"
                        triggers="hover"
                    >
                        <p>
                            <strong>Prescrição interna:</strong> Será faturado o procedimento 03.01.10.001-2 - ADMINISTRACAO DE MEDICAMENTOS NA ATENCÃO ESPECIALIZADA.
                        </p>

                        <p>
                            <strong>Exame laboratorial:</strong> Será faturado para o usuário que realizou a coleta de material o procedimento 02.01.02.004-1 - COLETA DE MATERIAL PARA EXAME LABORATORIAL. Ao realizar o exame, ele será faturado para o usuário parametrizado com o procedimento vinculado ao exame.
                        </p>

                        <p>
                            <strong>Exame de imagem:</strong> Será faturado para o médico solicitante o procedimento vinculado ao cadastro do exame.
                        </p>
                    </rkm-popover>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <box-profissional-exame-laboratorial :data="{ form, model }" />
    </rkm-form>
</template>

<script>
// Components.
import BoxAtendimentoMedico from './components/atendimento-medico/Index'
import BoxServicoEnfermagem from './components/servico-enfermagem/Index'
import BoxProfissionalExameLaboratorial from './components/profissional-exame-laboratorial/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: { BoxAtendimentoMedico, BoxServicoEnfermagem, BoxProfissionalExameLaboratorial },
    computed: {
        validations() {
            return {
                tempoAdicionalPlantao: {
                    min_value: 0,
                    max_value: 300,
                },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('prontoAtendimento.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        form: {
            atendimentoMedico: {},
        },
        model: {
            atendimentoMedico: {},
            faturamentoAutomaticoEnfermagem: false,
            exigirDuplaChecagemMedicamento: false,
            lotacoesExameLaboratorial: [],
        },
        additionals: {
            servicosEnfermagem: {}
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.addModelWatcher()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addModelWatcher() {

            this.$watch('model', {
                deep: true,
                handler(form) {

                    this.$emit('change', form)
                }
            })
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const servicosEnfermagem = this.model.servicosEnfermagem.map(servico => ({
                procedimentoCodigo: servico.procedimento.codigo
            }))

            const atendimentoMedico = {
                procedimentoPadraoCodigo: this.model.atendimentoMedico.procedimentoPadrao
                    ? this.model.atendimentoMedico.procedimentoPadrao.codigo : null,
                tipos: this.model.atendimentoMedico.tipos.map(t => ({
                    infraestruturaId: t.unidade.infraestrutura.id,
                    tipoId: t.tipo.id
                }))
            }

            const lotacoesExameLaboratorial = this.model.lotacoesExameLaboratorial
                .map(p => p.lotacaoId)

            return this.camelObjectKeysToSnakeRecursive({
                servicosEnfermagem,
                atendimentoMedico,
                faturamentoAutomaticoEnfermagem: this.model.faturamentoAutomaticoEnfermagem,
                assinaturaEletronica: this.model.assinaturaEletronica,
                exigirDuplaChecagemMedicamento: this.model.exigirDuplaChecagemMedicamento,
                lotacoesExameLaboratorial,
                tempoAdicionalPlantao: this.model.tempoAdicionalPlantao,
            })
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>

<style scoped>
.info { cursor: pointer; }
</style>